import { Radio } from '@smartgift/frontend-toolkit';
import styled, { css } from 'styled-components';

const Card = styled.div`
  background: var(--color-bg-default, #fff);
  border: 1px solid var(--color-border-default, #e5e8ef);
  border-radius: var(--size-border-radius-md, 4px);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: var(--size-gap-8);
  padding: var(--size-padding-16);
  position: relative;

  ${Radio.S.Input} {
    position: absolute;
    top: 6px;
    left: 6px;
    z-index: 1;
  }

  ${Radio.S.InputElement} {
    display: none;
  }

  ${({ checked }) => {
    return (
      checked &&
      css`
        border: 2px solid var(--color-accent-primary-default);
      `
    );
  }}
`;

export { Card };
